const checkHasLeader = (list: Record<string, unknown>[]): Record<string, unknown> | undefined =>
  list?.find((item) => item?.isLeader)

export default checkHasLeader
